module.exports = new __parcel__URL__("favicon-temp-family.9e1adb01.png").toString();